import { selector, selectorFamily } from 'recoil';
import { fetchAbilityList } from '../services';
import { imagePopupState, imagesDataState } from './state';

//定义item选择器
export const imageItemSelector = selectorFamily({
  key: 'ImageItemSelector1',
  get: (id: number) => ({ get }) => get(imagesDataState).entities.images[id]
});
export const materialItemSelector = selectorFamily({
  key: 'MaterialItemSelector',
  get: (id: number) => ({ get }) => get(imagesDataState).entities.materials[id]
});
export const abilityItemSelector = selectorFamily({
  key: 'AbilityItemSelector',
  get: (id: number) => ({ get }) => {
    const { abilities } = get(imagesDataState).entities;
    if (abilities) return abilities[id];
  }
});
export const typedMaterialItemSelector = selectorFamily({
  key: 'TypedMaterialItem',
  get: (type: ImageV3API.MaterialType | null) => ({ get }) => {
    if (type === null) return;
    const {
      entities: { materials }
    } = get(imagesDataState);
    const list = Object.values(materials);
    let result: ImageV3API.Material | undefined;
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i];
      if (item?.type === type) {
        if (!result) {
          result = item;
        } else {
          result = { ...result, number: result.number + item.number };
        }
      }
    }
    return result;
  }
});
export const pieceItemSelector = selectorFamily({
  key: 'TypedPieceItem',
  get: (type: number | null) => ({ get }) => {
    if (type === null) return;
    const {
      entities: { materials }
    } = get(imagesDataState);
    return Object.values(materials).find(
      v => v?.type === 0 && v.specialExtend?.piecesType === type
    );
  }
});
export const jewelItemSelector = selectorFamily({
  key: 'JewelItemSelector',
  get: (type: number | null) => ({ get }) => {
    const piece = get(pieceItemSelector(type));
    if (!piece || !piece.specialExtend?.polishToolId) return;
    const jewel = get(materialItemSelector(piece.specialExtend.polishToolId));
    return {
      ...piece,
      number: piece.number + (jewel?.number || 0)
    };
  }
});
export const pieceItemLogoSelector = selectorFamily({
  key: 'PieceItemLogo',
  get: (type: number | null) => ({ get }) => get(pieceItemSelector(type))?.logo
});
export const numberRankItemSelector = selectorFamily({
  key: 'NumberRankItem',
  get: (id: number) => ({ get }) =>
    get(imagesDataState).entities.numberRanks[id]
});
export const fightingRankItemSelector = selectorFamily({
  key: 'FightingRankItem',
  get: (id: number) => ({ get }) =>
    get(imagesDataState).entities.fightingRanks[id]
});

//定义列表选择器
export const myImagesListSelector = selector({
  key: 'MyImagesList1',
  get: ({ get }) => get(imagesDataState).result.userImageList
});
export const shopImagesListSelector = selector({
  key: 'ShopImagesList1',
  get: ({ get }) => get(imagesDataState).result.shopImageList
});
export const myMaterialsListSelector = selector({
  key: 'MyMaterialsList1',
  get: ({ get }) => {
    const {
      result: { materialList },
      entities: { materials }
    } = get(imagesDataState);
    return materialList.filter(
      v =>
        (materials[v]?.number || 0) > 0 &&
        materials[v]?.specialExtend?.piecesType !== 100
    );
  }
});
export const myPropsListSelector = selector({
  key: 'MyPropsList',
  get: ({ get }) => {
    const {
      result: { highToolsList }
    } = get(imagesDataState);
    return highToolsList;
  }
});
export const numberRankListSelector = selector({
  key: 'NumberRankList',
  get: ({ get }) => get(imagesDataState).result.numberRank.list
});

export const fightingRankListSelector = selector({
  key: 'FightingRankList',
  get: ({ get }) => get(imagesDataState).result.fightingRank.list
});

export const abilitiesListSelector = selector({
  key: 'AbilitiesList',
  get: () => fetchAbilityList()
});

export const additionsListSelector = selectorFamily({
  key: 'AdditionsList',
  get: (type: number) => ({ get }) => {
    const data = get(imagesDataState);
    if (type === 1) {
      return data.result.materialList.filter(id => {
        const item = data.entities.materials[id];
        return (
          item &&
          item.specialExtend &&
          (item.specialExtend.piecesType === 0 ||
            item.specialExtend.piecesType === 100)
        );
      });
    } else if (type === 2) {
      const fn = (id: number) => {
        const item = data.entities.materials[id];
        return item && item.type === 4; //   进阶卡
      };
      return [
        ...data.result.materialList.filter(fn),
        ...data.result.highToolsList.filter(fn)
      ];
    } else if (type === 3) {
      const fn = (id: number) => {
        const item = data.entities.materials[id];
        return item && item.type === 6;
      };
      return [
        ...data.result.materialList.filter(fn),
        ...data.result.highToolsList.filter(fn)
      ];
    }
    return [] as number[];
  }
});

export const imagePopupVisibleSelector = selectorFamily<
  boolean,
  ImageV3State.PopupType
>({
  key: 'ImagePopupVisibleSelector',
  get: (type: ImageV3State.PopupType) => ({ get }) =>
    get(imagePopupState(type)).visible,
  set: (type: ImageV3State.PopupType) => ({ set }, value) =>
    set(imagePopupState(type), v => ({ ...v, visible: value as any }))
});
